import '../../assets/index33.css';var $ = Object.defineProperty, j = Object.defineProperties;
var Y = Object.getOwnPropertyDescriptors;
var b = Object.getOwnPropertySymbols;
var N = Object.prototype.hasOwnProperty, R = Object.prototype.propertyIsEnumerable;
var D = (e, t, o) => t in e ? $(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o, a = (e, t) => {
  for (var o in t || (t = {}))
    N.call(t, o) && D(e, o, t[o]);
  if (b)
    for (var o of b(t))
      R.call(t, o) && D(e, o, t[o]);
  return e;
}, i = (e, t) => j(e, Y(t));
var w = (e, t) => {
  var o = {};
  for (var r in e)
    N.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
  if (e != null && b)
    for (var r of b(e))
      t.indexOf(r) < 0 && R.call(e, r) && (o[r] = e[r]);
  return o;
};
import { jsx as s, jsxs as v } from "react/jsx-runtime";
import M from "react";
import { Flex as Z } from "../Flex/index.js";
import { Text as G } from "../Text/index.js";
import { ProgressIndicator as J } from "../ProgressIndicator/index.js";
import { Button as T } from "../Button/index.js";
import { TriangleExclamationFarFAIcon as K, CircleInfoFarFAIcon as L, CircleExclamationFarFAIcon as V, XMarkFarFAIcon as X } from "../Icons/index.js";
import { f as q, u as H, B as O, b as Q } from "../../factory-ueRxoNOV.js";
import { r as U } from "../../rem-CMQJ_ZTp.js";
import { e as ee } from "../../get-size-Bc1Pz5yf.js";
import { c as oe } from "../../create-vars-resolver-Bzbn9G-G.js";
import { u as te } from "../../use-styles-DToiHEa6.js";
import { C as re } from "../../CloseButton-BysQSF2E.js";
import { u as se } from "../../use-id-D2tGiO9x.js";
var z = { root: "m_66836ed3", wrapper: "m_a5d60502", body: "m_667c2793", title: "m_6a03f287", label: "m_698f4f23", icon: "m_667f2a6a", message: "m_7fa78076", closeButton: "m_87f54839" };
const ae = {}, ie = oe(
  (e, { radius: t, color: o, variant: r, autoContrast: m }) => {
    const n = e.variantColorResolver({
      color: o || e.primaryColor,
      theme: e,
      variant: r || "light",
      autoContrast: m
    });
    return {
      root: {
        "--alert-radius": t === void 0 ? void 0 : ee(t),
        "--alert-bg": o || r ? n.background : void 0,
        "--alert-color": n.color,
        "--alert-bd": o || r ? n.border : void 0
      }
    };
  }
), B = q((e, t) => {
  const o = H("Alert", ae, e), F = o, {
    classNames: r,
    className: m,
    style: n,
    styles: A,
    unstyled: p,
    vars: g,
    radius: x,
    color: E,
    title: _,
    children: u,
    id: d,
    icon: f,
    withCloseButton: h,
    onClose: W,
    closeButtonLabel: P,
    variant: y,
    autoContrast: he
  } = F, S = w(F, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "radius",
    "color",
    "title",
    "children",
    "id",
    "icon",
    "withCloseButton",
    "onClose",
    "closeButtonLabel",
    "variant",
    "autoContrast"
  ]), c = te({
    name: "Alert",
    classes: z,
    props: o,
    className: m,
    style: n,
    classNames: r,
    styles: A,
    unstyled: p,
    vars: g,
    varsResolver: ie
  }), C = se(d), I = _ && `${C}-title` || void 0, k = `${C}-body`;
  return /* @__PURE__ */ s(
    O,
    i(a(i(a({
      id: C
    }, c("root", { variant: y })), {
      variant: y,
      ref: t
    }), S), {
      role: "alert",
      "aria-describedby": k,
      "aria-labelledby": I,
      children: /* @__PURE__ */ v("div", i(a({}, c("wrapper")), { children: [
        f && /* @__PURE__ */ s("div", i(a({}, c("icon")), { children: f })),
        /* @__PURE__ */ v("div", i(a({}, c("body")), { children: [
          _ && /* @__PURE__ */ s("div", i(a({}, c("title")), { "data-with-close-button": h || void 0, children: /* @__PURE__ */ s("span", i(a({ id: I }, c("label")), { children: _ })) })),
          u && /* @__PURE__ */ s("div", i(a({ id: k }, c("message")), { "data-variant": y, children: u }))
        ] })),
        h && /* @__PURE__ */ s(
          re,
          i(a({}, c("closeButton")), {
            onClick: W,
            variant: "transparent",
            size: 16,
            iconSize: 16,
            "aria-label": P,
            unstyled: p
          })
        )
      ] }))
    })
  );
});
B.classes = z;
B.displayName = "@mantine/core/Alert";
const le = "Alert-module__flex___YYwWE", ne = "Alert-module__iconWithTitle___5pESz", ce = "Alert-module__message___J9-hZ", me = "Alert-module__root___W6eAf", de = "Alert-module__title___7epKE", _e = "Alert-module__wrapper___RPRmA", ue = "Alert-module__hasDismiss___ihCzE", pe = "Alert-module__hasDismissAction___pThGY", fe = "Alert-module__buttonsContainer___ibZ8r", l = {
  flex: le,
  iconWithTitle: ne,
  message: ce,
  root: me,
  title: de,
  wrapper: _e,
  hasDismiss: ue,
  hasDismissAction: pe,
  buttonsContainer: fe
}, Te = M.forwardRef((E, x) => {
  var _ = E, {
    action: e,
    actionLabel: t,
    children: o,
    onClose: r,
    title: m,
    variant: n = "info",
    className: A,
    width: p
  } = _, g = w(_, [
    "action",
    "actionLabel",
    "children",
    "onClose",
    "title",
    "variant",
    "className",
    "width"
  ]);
  const u = Q();
  let d;
  switch (n) {
    case "error":
      d = /* @__PURE__ */ s(V, { color: u.colors.red[5], filled: !0 });
      break;
    case "info":
      d = /* @__PURE__ */ s(L, { color: u.colors.blue[6], filled: !0 });
      break;
    case "warning":
      d = /* @__PURE__ */ s(K, { color: u.colors.orange[5], filled: !0 });
      break;
    case "loading":
      d = /* @__PURE__ */ s(J, { size: U(16) });
      break;
  }
  const f = m ? /* @__PURE__ */ s(G, { size: "md", prominent: !0, className: l.title, children: m }) : void 0, h = [
    A || "",
    r ? l.hasDismiss : "",
    e && r ? l.hasDismissAction : ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ s(
    B,
    i(a({}, g), {
      classNames: {
        closeButton: l.closeButton,
        icon: m ? l.iconWithTitle : void 0,
        message: l.message,
        root: l.root,
        wrapper: l.wrapper
      },
      title: f,
      className: h,
      style: { width: p },
      icon: d,
      ref: x,
      "data-variant": n,
      withCloseButton: !1,
      children: /* @__PURE__ */ v(Z, { className: l.flex, children: [
        o,
        /* @__PURE__ */ v("div", { className: l.buttonsContainer, children: [
          e && /* @__PURE__ */ s(
            T,
            {
              "data-plum-id": "alert-action-button",
              onClick: e,
              variant: "secondary",
              children: t
            }
          ),
          r && /* @__PURE__ */ s(
            T,
            {
              onClick: r,
              variant: "tertiary",
              size: "sm",
              children: /* @__PURE__ */ s(X, {})
            }
          )
        ] })
      ] })
    })
  );
});
export {
  Te as Alert
};
